<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Profile' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-profile />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Change Password' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Club Details' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-club-info />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-book" :label="!isSmallerScreen ? 'Booking' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-booking/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-mail" :label="!isSmallerScreen ? 'Mail' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-mail/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-eye" :label="!isSmallerScreen ? 'Theme' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-theme 
          :footerType             = "footerType"
          :hideScrollToTop        = "hideScrollToTop"
          :navbarType             = "navbarType"
          :navbarColor            = "navbarColor"
          :routerTransition       = "routerTransition" />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserSettingsMail from "./UserSettingsMail.vue"
import UserSettingsTheme from "./UserSettingsTheme.vue"
import UserSettingsProfile from "./UserSettingsProfile.vue"
import UserSettingsBooking from "./UserSettingsBooking.vue"
import UserSettingsBookingFeedback from "./UserSettingsBookingFeedback.vue"
import UserSettingsChangePassword from "./UserSettingsChangePassword.vue"
import UserSettingsClubInfo from "./UserSettingsClubInfo.vue"
import UserSettingsNotifications from "./UserSettingsNotifications.vue"
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'
import themeConfig         from '@/../themeConfig.js'
import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"

export default {
  components: {
    UserSettingsMail,
    UserSettingsTheme,
    UserSettingsProfile,
    UserSettingsBooking,
    UserSettingsBookingFeedback,
    UserSettingsChangePassword,
    UserSettingsClubInfo,
    UserSettingsNotifications,
  },
  data() {
    return {
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems      : navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',

    }
  },
  methods: {
    getClubData() {
      this.$store.dispatch("clubManagement/getClubData")
        .then(res => { })
        .catch(err => { })
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  created() {
    if(!moduleClubManagement.isRegistered) {
        this.$store.registerModule('clubManagement', moduleClubManagement)
        moduleClubManagement.isRegistered = true
    }

    this.getClubData()
  },
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
